import type React from "react";
import { useContext } from "react";
import { useDrag } from "react-dnd";
import { GiSpeaker } from "react-icons/gi";
import { MdDragIndicator } from "react-icons/md";
import { LanguageContext, useSpeakingContext } from "../../../../app/context";
import { playSynthesisUtterance } from "../../../../shared/helpers";

type Props = {
	word: string;
	matchWithAudio?: boolean;
};
export const Word: React.FC<Props> = ({ word, matchWithAudio }) => {
	const { isSpeaking, setIsSpeaking, currentIsClicked, setCurrentIsClicked } =
		useSpeakingContext();
	const [{ isDragging }, drag] = useDrag({
		type: "words-defs",
		item: { word },
		canDrag: word !== "",
		collect: (monitor) => ({
			isDragging: !!monitor.isDragging(),
		}),
	});

	const { language } = useContext(LanguageContext);

	const prefixClass = "match-words";

	return (
		<li
			className={`${prefixClass}__word-item`}
			ref={drag}
			style={{ opacity: isDragging ? 0.5 : 1 }}
		>
			{word && <MdDragIndicator className={`${prefixClass}__drag-icon`} />}
			{matchWithAudio ? (
				<button
					type="button"
					disabled={isSpeaking}
					className={`${prefixClass}__play-sound${word === currentIsClicked && isSpeaking ? "--active" : ""}`}
					onClick={() => {
						playSynthesisUtterance({
							word,
							language,
							onStart: () => setIsSpeaking(true),
							onEnd: () => setIsSpeaking(false),
						});
						setCurrentIsClicked("");
						setCurrentIsClicked(word);
					}}
				>
					<GiSpeaker />
				</button>
			) : (
				<p>{word}</p>
			)}
		</li>
	);
};
